


export default {
   // 公共
   hello:"Hello~",
   welcome: "Chào mừng đến với Trung tâm chăm khóc khách hàng của Plus18 Games",
    connecting: "Dịch vụ chăm sóc khách hàng đang được kết nối...",
    connected: "Dịch vụ chăm sóc khách hàng đã kết nối xong",
    waitting: "Vui lòng chờ trong giây lát ",
    click_to_chat: "Vui lòng nhấn nút góc dưới bên phải để bắt đầu trò chuyện",
    email:"Email hỗ trợ khách hàng",
    kefu:"chăm sóc khách hàng",
    kefu_center:"Trung tâm chăm sóc khách hàng",
}